import { ReactComponent as HigIconHead } from "../../assets/svg/hig-logo.svg";

// Components

import { UserModal } from "./UserModal";
import { NotificationModal } from "./NotificationModal";

export const Header = (props) => {
  return (
    <div className="header-container">
      <div className="header">
        <div
          className="header-title font-size-main-2"
          style={{
            fontWeight: "700",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <HigIconHead style={{ width: "50px" }} />
          <span>{props.title}</span>
        </div>
        {props.leftTitle ? (
          <div className="flex flex-row-reverse flex-items-center flex-content-space-between left-title-content">
            <UserModal />
            <div className=" font-size-main-1" style={{ fontWeight: "500" }}>
              {props.leftTitle}
            </div>
          </div>
        ) : (
          <div className="ml-16" style={{ display: "flex" }}>
            <NotificationModal /> <UserModal />
          </div>
        )}
      </div>
    </div>
  );
};
